<template>
  <ModalContainer queryParam="editLab" ref="modalEditImagen" size="xl">
    <b-card class="m-0">
      <h3 class="mb-2 text-center">Editar laboratorio As400</h3>

      <FormAddLab400
        v-if="indexToEdit"
        :examenes400="examenes400"
        :indexToEdit="indexToEdit"
      />
      
    </b-card>
  </ModalContainer>
</template>

<script>
import { ModalContainer } from '@/shared/components';
import FormAddLab400 from "./FormAddLab400.vue";

export default {

  name: "EditarEnvioLab400",

  props: {
    examenes400: {
      type: Array,
      required: true
    },

  },
  
  components: {
    ModalContainer,
    FormAddLab400
  },

  created() {
    this.indexToEdit = this.$route.query.editAux
  },

  data(){
    return {
      indexToEdit: null,
    }
  },

  watch:{
    '$route.query.editLab':{
      immediate: true,
      handler(){
        this.indexToEdit = this.$route.query.editLab
      }
    }
  }
}
</script>

<style>

</style>